var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTestOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-B-testing",
    transform: "translate(-713.000000, -321.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-test-options",
    transform: "translate(713.000000, 321.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05,2.1 L7.77,0.28 C7.7,0.14 7.56,0 7.42,0 L6.58,0 C6.44,0 6.23,0.14 6.23,0.28 L5.95,2.1 L8.05,2.1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95,11.9 L6.23,13.72 C6.23,13.86 6.37,14 6.58,14 L7.42,14 C7.56,14 7.77,13.86 7.77,13.72 L8.05,11.9 L5.95,11.9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,8.05 L13.72,7.77 C13.86,7.77 14,7.63 14,7.42 L14,6.58 C14,6.44 13.86,6.23 13.72,6.23 L11.9,5.95 L11.9,8.05 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1,5.95 L0.28,6.23 C0.14,6.3 0,6.44 0,6.58 L0,7.42 C0,7.56 0.14,7.77 0.28,7.77 L2.1,8.05 L2.1,5.95 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46,2.24 L4.27,0.84 C4.2,0.7 3.99,0.63 3.85,0.77 L3.15,1.19 C3.01,1.26 2.94,1.4 3.01,1.54 L3.64,3.29 L5.46,2.24 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54,11.76 L9.73,13.16 C9.87,13.3 10.01,13.3 10.15,13.23 L10.85,12.81 C10.99,12.74 11.06,12.53 10.99,12.39 L10.36,10.64 L8.54,11.76 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76,5.46 L13.16,4.27 C13.3,4.2 13.37,3.99 13.23,3.85 L12.81,3.15 C12.74,3.01 12.53,2.94 12.39,3.01 L10.64,3.64 L11.76,5.46 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24,8.54 L0.84,9.73 C0.7,9.8 0.63,10.01 0.77,10.15 L1.19,10.85 C1.26,10.99 1.47,11.06 1.61,10.99 L3.36,10.36 L2.24,8.54 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29,3.64 L1.54,3.01 C1.4,2.94 1.26,3.01 1.12,3.15 L0.7,3.85 C0.63,3.99 0.7,4.2 0.84,4.27 L2.24,5.46 L3.29,3.64 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.71,10.36 L12.46,10.99 C12.6,11.06 12.81,10.99 12.88,10.85 L13.3,10.15 C13.37,10.01 13.37,9.8 13.23,9.73 L11.83,8.54 L10.71,10.36 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.36,3.29 L10.99,1.54 C11.06,1.4 10.99,1.19 10.85,1.12 L10.15,0.7 C10.01,0.63 9.8,0.7 9.73,0.84 L8.54,2.24 L10.36,3.29 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64,10.71 L3.01,12.46 C2.94,12.6 3.01,12.81 3.15,12.88 L3.85,13.3 C3.99,13.37 4.2,13.3 4.27,13.16 L5.46,11.76 L3.64,10.71 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,9.1 C5.81,9.1 4.9,8.19 4.9,7 C4.9,5.81 5.81,4.9 7,4.9 C8.19,4.9 9.1,5.81 9.1,7 C9.1,8.19 8.19,9.1 7,9.1 Z M7,6.3 C6.58,6.3 6.3,6.58 6.3,7 C6.3,7.42 6.58,7.7 7,7.7 C7.42,7.7 7.7,7.42 7.7,7 C7.7,6.58 7.42,6.3 7,6.3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(2.100000, 2.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,0 C2.17,0 0,2.17 0,4.9 C0,7.63 2.17,9.8 4.9,9.8 C7.63,9.8 9.8,7.63 9.8,4.9 C9.8,2.17 7.63,0 4.9,0 Z M4.9,6.3 C4.13,6.3 3.5,5.67 3.5,4.9 C3.5,4.13 4.13,3.5 4.9,3.5 C5.67,3.5 6.3,4.13 6.3,4.9 C6.3,5.67 5.67,6.3 4.9,6.3 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.3,
    y: 2.1,
    width: 1.4,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(4.553465, 8.413125) rotate(-29.992901) translate(-4.553465, -8.413125) ",
    x: 2.45343432,
    y: 7.71311477,
    width: 4.20006136,
    height: 1.40002045
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(9.437855, 8.377145) rotate(-60.007099) translate(-9.437855, -8.377145) ",
    x: 8.73784477,
    y: 6.27711432,
    width: 1.40002045,
    height: 4.20006136
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,12.6 C3.92,12.6 1.4,10.08 1.4,7 C1.4,3.92 3.92,1.4 7,1.4 C10.08,1.4 12.6,3.92 12.6,7 C12.6,10.08 10.08,12.6 7,12.6 Z M7,2.8 C4.69,2.8 2.8,4.69 2.8,7 C2.8,9.31 4.69,11.2 7,11.2 C9.31,11.2 11.2,9.31 11.2,7 C11.2,4.69 9.31,2.8 7,2.8 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestOptions);
export default __webpack_public_path__ + "static/media/icon-test-options.6e45d627c257dc2d89ec99b165867c9e.svg";
export { ForwardRef as ReactComponent };